$(".header__utility-items li > a").not(".logged, .wishlist a").on("click", function(e) {
  e.preventDefault();
  const $this = $(this);
  const $dropdown = $this.next(".dropdown");
  $this.parent().toggleClass("active");
  $this.parent().siblings("li").removeClass("active");
  if ($this.parent().hasClass("search-item") || $this.parent().hasClass("location-item")) {
    setTimeout(function() {
      $dropdown.find(".field").focus();
    }, 300);
  }
});

$(document).mouseup(function(e) {
  var container = $(".header");

  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $(".header__utility .active").removeClass("active");
  }
});



// WEBPACK FOOTER //
// ../assets/js/utility.js